// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2HdpF","calendarButtons":"ClockData_calendarButtons__1QpJn"};